{
	"textures": [
		{
			"image": "candle_small.png",
			"format": "RGBA8888",
			"size": {
				"w": 69,
				"h": 199
			},
			"scale": 1,
			"frames": [
				{
					"filename": "candle/candle04",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 76,
						"h": 67
					},
					"spriteSourceSize": {
						"x": 6,
						"y": 5,
						"w": 67,
						"h": 58
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 67,
						"h": 58
					}
				},
				{
					"filename": "candle/candle03",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 76,
						"h": 67
					},
					"spriteSourceSize": {
						"x": 6,
						"y": 4,
						"w": 67,
						"h": 46
					},
					"frame": {
						"x": 1,
						"y": 61,
						"w": 67,
						"h": 46
					}
				},
				{
					"filename": "candle/candle02",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 76,
						"h": 67
					},
					"spriteSourceSize": {
						"x": 15,
						"y": 4,
						"w": 49,
						"h": 46
					},
					"frame": {
						"x": 1,
						"y": 109,
						"w": 49,
						"h": 46
					}
				},
				{
					"filename": "candle/candle01",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 76,
						"h": 67
					},
					"spriteSourceSize": {
						"x": 14,
						"y": 4,
						"w": 37,
						"h": 41
					},
					"frame": {
						"x": 1,
						"y": 157,
						"w": 37,
						"h": 41
					}
				},
				{
					"filename": "candle/candle00",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 76,
						"h": 67
					},
					"spriteSourceSize": {
						"x": 17,
						"y": 4,
						"w": 27,
						"h": 41
					},
					"frame": {
						"x": 40,
						"y": 157,
						"w": 27,
						"h": 41
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:9dc3750a87138cd2b4f211fc56ad8cfe:4cdcdf591b34428f947af744bcc0ad90:61df024387051efeffac169dbbc6326d$"
	}
}
